import { FilteredCreditApplication } from '@applyonline/shared'
import { ECreditApplicationStatus, EDecision } from '@if/core/types'
import { hasMissingDocuments, hasSignedContract } from '../../data/credit-application-selectors'

export const isServerAnalysingCredit = (creditApp: FilteredCreditApplication | null): boolean => {
  return (
    creditApp !== null &&
    creditApp.status === ECreditApplicationStatus.Active &&
    creditApp.normsDecision === null &&
    creditApp.consentHardHit === true
  )
}

export const canPollCreditApp = (creditApp: FilteredCreditApplication | null): boolean => {
  if (creditApp) {
    let maxTime = new Date()
    const thirtySeconds = 30 * 1000
    maxTime = new Date(maxTime.getTime() - thirtySeconds)
    const creditAppTime = new Date(creditApp.updatedOn)
    return creditAppTime >= maxTime
  }
  return false
}

export const hasDecisionningError = (creditApp: FilteredCreditApplication | null): boolean => {
  if (creditApp) {
    const isServerDecisionning = isServerAnalysingCredit(creditApp)
    const canPoll = canPollCreditApp(creditApp)

    return (isServerDecisionning && !canPoll) || creditApp.finalDecision?.decision === EDecision.Error
  }
  return false
}

export type HighLevelPage =
  | 'loading' // loading the app is loading
  | 'notFound' // id does not exists
  | 'analysis-running' // server is analysing hard hit
  | 'decisionning-error' // either takes more time than normal to make a decision, has a decision error
  | 'hardhit-result' // we have a hard hit that yields a non approved final decision (Client is banned)
  | 'approved' // the customer clicked "get that loan" and final decision is approved
  | 'contract'
  | 'funding' // the contract has been signed
  | 'closed' // completed
export const computeHighLevelPage = (
  creditApp: FilteredCreditApplication | null,
  isFetchingCreditApp: boolean,
): HighLevelPage => {
  if (!creditApp) {
    if (isFetchingCreditApp) return 'loading'
    return 'notFound'
  }

  if (
    creditApp.status === ECreditApplicationStatus.Cancelled ||
    creditApp.status === ECreditApplicationStatus.Completed
  )
    return 'closed'
  if (isServerAnalysingCredit(creditApp)) return 'analysis-running'
  if (hasDecisionningError(creditApp)) return 'decisionning-error'
  if (hasSignedContract(creditApp) && !hasMissingDocuments(creditApp)) return 'funding'
  if (creditApp.finalDecision.decision === EDecision.Approved) return 'approved'
  return 'hardhit-result'
}
